import { render } from "./DelayItem.vue?vue&type=template&id=c13575ea"
import script from "./DelayItem.vue?vue&type=script&lang=js"
export * from "./DelayItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__